import { defineComponent as _defineComponent } from 'vue'
export interface Props<T = unknown> {
  label: string;
  items: ListItem<T>[];
  text: (item: T) => string;
  subtext: (item: T) => string;
}


import { computed } from 'vue';

import { ListItem } from './SelectionPanel.vue';

declare module 'vue/types/vue' {
  export interface Vue {
    SelectionGroup: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'SelectionGroup' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: null,
    items: null,
    text: null,
    subtext: null
  },
  setup(__props: any) {

const props = __props as {
  label: string;
  items: ListItem<T>[];
  text: (item: T) => string;
  subtext: (item: T) => string;
};

/**
 * `SelectionGroup` component properties.
 */


const itemsLength = computed(() => props.items.length);

const groupItems = computed(() => {
  return props.items.map(({ id, item }) => {
    return { id, text: props.text(item), subtext: props.subtext(item) };
  });
});

return { __sfc: true,props, itemsLength, groupItems }
}

})